import { TFormalOffer } from './formalOffers.types';

/**
 * Checks if an offer is an Interest Only Plus (6 month interest only period) offer
 *
 * @param formalOffer A formal offer object.
 * @returns `true` if the offer.interest_only_repayments is 6.
 */
export const isInterestOnlyPlusOffer = (offer: TFormalOffer): boolean => {
    return offer.interest_only_repayments === 6;
};
